"use client"

import { useMemo } from "react"
import { useLocale, useTranslations } from "next-intl"
import { useQualityCopy } from "@/components/i18n/quality-copy-context"
import { getQualitySectionFormatters } from "@/lib/i18n/quality-section-presentation"
import { getQualityChangeFormatters } from "@/lib/conversation-quality/change-display"
import { getQualityLearningFormatters } from "@/lib/conversation-quality/self-learning-display"

export function useQualityChanges() {
  const locale = useLocale()
  const t = useTranslations("QualityChanges")
  const { TOPIC_CATEGORY_LABELS } = useQualityCopy()
  return useMemo(() => getQualityChangeFormatters(t, locale, TOPIC_CATEGORY_LABELS), [t, locale, TOPIC_CATEGORY_LABELS])
}

export function useQualityLearning() {
  const locale = useLocale()
  const t = useTranslations("QualityLearning")
  return useMemo(() => getQualityLearningFormatters(t, locale), [t, locale])
}

export function useQualitySections() {
  const locale = useLocale()
  const t = useTranslations("QualityCounts")
  return useMemo(() => getQualitySectionFormatters(t, locale), [t, locale])
}
